<template>
  <!-- 专属代购 -->
  <div class="shoper_item_discovery">
    <div class="shoper_title">
      <span class="span1">专属导购</span>
      <span class="span2">实物体验 免费服务</span>
      <span class="span3" @click="goToBrand">进店逛逛</span>
    </div>
    <div class="shoper_beeinfo">
      <div class="div">
        <div class="div0">
          <van-image
            @click="gotoBeeIndex"
            round
            width="50"
            height="50"
            fit="cover"
            :src="item && item.beesAvatar+'?x-oss-process=style/style_index_bee_profile'"
          ></van-image>
        </div>
        <div class="div1">
          <p class="p1">
            <span>{{item.beesName}}</span>
            <span class="tag">{{item.isOnline==='y'?'在线':'离线'}}</span>
          </p>
          <p class="p2">{{`欢迎光临${item.branchName}，我是您的小蜜蜂${item.beesName}，很乐意为您效劳！`}}</p>
        </div>
      </div>
      <!-- <div @click="catbees" class="icon_info">
        <van-image :src="icon" width="20" height="20" />
        <p>咨询TA</p>
        <van-icon name="chat-o" size="22.5px" @click="catbees"/>
      </div> -->
    </div>
  </div>
</template>
<script>
import utils from "@/utils/common";
export default {
  data() {
    return {
      icon: require("@/assets/image/find_wechat_icon.png"),
      gioObj: {
        entryShape_var: "发现模块",
        entryPage_var: document.title,
        functionName_var: "咨询他",
        primarySort_var: "",
        secondSort_var: "",
        thirdSort_var: "",
        fourthSort_var: "",
        brand_var: this.item.branchName || "",
        productName_var: this.item.goodsTitle || ""
      }
    };
  },
  props: {
    item: {
      default: function() {
        return {};
      },
      type: Object
    },
    beesInfo: {
      default: function() {
        return {};
      },
      type: Object
    },
    type: {
      default: "user"
    }
  },
  methods: {
    catbees() {
      let that = this
      if (this.type === "bees") {
        return this.$toast("暂无权限");
      }
      let prmes = {
        easemobname: this.item.easemobName || this.item.easemobname,
        goodsId: this.item && this.item.goodsId ? this.item.goodsId : 0,
        discoverId: this.item.id,
        key: "beeDiscoverChat",
        nimname: this.item.nimname || ""
      };
      this.$store.dispatch('setUserTrack',{
        trackType:'CONSULT_BEE_BY_DISCOVERY',
        trackMap:{discoveryId:this.item.id,beesId:this.item.beesId}
      })
      if (this.item.discoverType == "NORMAL") {
        utils.beeDiscoverChat(prmes);
      } else {
        utils.beeDiscoverChat(prmes);
      }
      that.$publicFunc.getJumpSingeOrTeam({
        statusParmes: {
          branchId: that.item.branchId
        },
        teamParmes: {
          branchId: that.item.branchId
        },
        callback: function (status, teamDetail) {
          prmes.teamChatId = status.isTeamChat && teamDetail.teamChatId ? teamDetail.teamChatId : ""
          utils.beeChatGioReport({
            gio: that.gioObj,
            business: prmes
          });
        }
      })
    },
    getGoodscategory() {
      this.http({
        url: "/order/app/item/findgoodscategory/" + this.item.goodsId,
        method: "GET"
      }).then(rps => {
        if (rps.code === 200) {
          this.gioObj.primarySort_var = rps.data.categoryLevel1;
          this.gioObj.secondSort_var = rps.data.categoryLevel2;
          this.gioObj.thirdSort_var = rps.data.categoryLevel3;
          this.gioObj.fourthSort_var = rps.data.categoryLevel4;
        }
      });
    },
    goToBrand() {
      console.log(this.item);
      let brandchId = this.item.branchId
        ? this.item.branchId
        : this.item.brandId;
      if (brandchId) {
        let url = location.origin + "/h5user/brandindex?brandId=" + brandchId;
        utils.jumpToNewPage({
          url: url,
          noTitle: "1",
          action:{tm:"4090100",tp:{branchId:parseInt(brandchId)}}
        });
      }
    },
    gotoBeeIndex() {
      this.$router.push({
        path: "userBeeIndex",
        query: {
          beesUserId: this.item.beesUserId
        }
      });
    },
  },
  created() {
    if (this.item && this.item.goodsId) {
      this.getGoodscategory();
    }
  }
};
</script>
<style lang="less" scoped>
.shoper_item_discovery {
  margin-top: 10px;
  background-color: #fff;
  padding: 20px 26px 10px;
  .shoper_title {
    // padding: 20px 0;
    padding-bottom: 20px;
    line-height: 70px;
    .span1 {
      font-size: 28px;
      color: #333;
      padding: 5px 20px;
      border-left: 14px solid #f8d541;
    }
    .span2 {
      font-size: 26px;
      color: #999;
      padding: 5px 0;
    }
    .span3 {
      text-align: right;
      background-color: #f8d541;
      font-size: 24px;
      color: #333;
      padding: 8px 20px;
      border-radius: 20px;
      margin-left: 160px;
    }
  }
  .shoper_beeinfo {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    color: #333;
    padding: 30px;
    box-sizing: border-box;
    .div {
      // flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .div1 {
        p {
          font-size: 20px;
        }
        padding: 0 20px;
        .p1 {
          padding: 10px 0;
          display: flex;
          align-items: center;
          span {
            font-size: 24px;
            font-weight: 500;
          }
          .tag {
            font-size: 18px;
            padding: 5px 14px;
            display: inline-block;
            font-weight: 400;
            background-color: #f8d541;
            border-radius: 18px;
            margin: 0 10px;
          }
        }
        .p2 {
          font-size: 18px;
        }
      }
    }
    .icon_info {
      text-align: center;
      color: #f8a651;
      font-size: 20px;
    }
  }
}
</style>